import physicianReducers from './reducer';
import * as physicianActions from './reducer';

export { physicianActions };

export default physicianReducers;
